import React from "react";
import "./services.css";
import v2 from "../../img/v2.png";
import v4 from "../../img/v4.png";
import e from "../../img/e.png";
import o from "../../img/o.png";
import webD from "../../img/webD.png";
import tech2 from "../../img/tech2.png";
import Card from "../Card/Card";
import MohamedAliResume from "./Mohamed Ali Resume.pdf";
import { themeContext } from "../../Context/Context";
import { useContext } from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react/dist/iconify.js";

const Services = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const transition = { duration: 2, type: "spring" };

  return (
    <div className="services">
      <div className="serviceWrapper">
      {/* <motion.div
        className="left"
        initial={{ left: "-30%" }}
        whileInView={{ left: "0%" }}
        transition={transition}
      >
        <span
          style={{
            color: darkMode ? "white" : "",
          }}
        >
          Web Development Services
        </span>{" "}
        <br />
        <span>MERN STACK Software as a Service</span>
        <br />
        <div className="space-y-6 text-sm text-gray-800">
  <div>
    <h2 className="text-lg font-semibold mb-2">MERN Development Services</h2>
    <div className="flex flex-wrap gap-2">
      <span className="bg-gray-100 px-3 py-1 rounded-full">Full MERN Stack Web App Development</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Custom React Dashboards (Admin Panels / Analytics UI)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Build RESTful APIs with Node/Express/MongoDB</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Convert Figma/PSD Designs to React (Responsive)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Integrate 3rd-Party APIs (Stripe, SendGrid, etc.)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">MERN App Deployment (Vercel, Render, VPS)</span>
    </div>
  </div>
  <br />
  <div>
    <h2 className="text-lg font-semibold mb-2">Authentication & User Management</h2>
    <div className="flex flex-wrap gap-2">
      <span className="bg-gray-100 px-3 py-1 rounded-full">Secure Auth System (JWT + Refresh Tokens + Roles)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Role-Based Access (Admin/User Permissions)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Email Verification + Password Reset</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Team Accounts (Multi-User Support)</span>
    </div>
  </div>
  <br />
  <div>
    <h2 className="text-lg font-semibold mb-2">Payment & Subscription Services</h2>
    <div className="flex flex-wrap gap-2">
      <span className="bg-gray-100 px-3 py-1 rounded-full">Stripe Subscription Integration (Monthly/Yearly Plans)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Webhooks (Stripe Events Handling)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Plan Upgrades/Downgrades</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Usage Limits / Metered Billing</span>
    </div>
  </div>
  <br />
  <div>
    <h2 className="text-lg font-semibold mb-2">SaaS Features & Analytics</h2>
    <div className="flex flex-wrap gap-2">
      <span className="bg-gray-100 px-3 py-1 rounded-full">Build SaaS MVP (Auth, Billing, Dashboard)</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Basic Analytics (Charts, Stats, Data Visualization)</span>
    </div>
  </div>
  <br />
  <div>
    <h2 className="text-lg font-semibold mb-2">Bug Fixing & Enhancements</h2>
    <div className="flex flex-wrap gap-2">
      <span className="bg-gray-100 px-3 py-1 rounded-full">Fix Bugs in React / Node / Express Apps</span>
      <span className="bg-gray-100 px-3 py-1 rounded-full">Custom API Routes (Protected/Public)</span>
    </div>
  </div>
</div>

        <span
          style={{
            color: darkMode ? "white" : "",
          }}
        >
          Custom Web Development, Responsive & Mobile-First Design, Performance
          Optimization, Secure & Scalable Solutions, UI/UX Design, Full-Stack
          Web Development, API Integration, Maintenance & Support, SEO Best
          Practices, eCommerce Development
        </span>
        <div className="buttonDiv">
          <a href={MohamedAliResume} download className="serviceBtn">
            <span>Download CV</span>
            <Icon icon="line-md:download-loop" width="1.5rem" height="1.5rem" />
          </a>{" "}
        </div>
      </motion.div> */}
      <motion.div
        className="left"
        initial={{ left: "-30%" }}
        whileInView={{ left: "0%" }}
        transition={transition}
      >
        <span style={{ color: darkMode ? "white" : "" }}>
          Web Development Services
        </span>
        <br />
        <span>MERN STACK Saas - Software as a Service</span>
        <br />

        {/* <div className="services-container">
          <div className="service-section">
            <h2>MERN Development Services</h2>
            <div className="service-tags">
              <span>Full MERN Stack Web App Development</span>
              <span>Custom React Dashboards (Admin Panels / Analytics UI)</span>
              <span>Building RESTful APIs with Node/Express/MongoDB</span>
              <span>Converting Figma/PSD Designs to React (Responsive)</span>
              <span>Integrating 3rd-Party APIs (Stripe, SendGrid, etc.)</span>
              <span>MERN App Deployment (Vercel, Render, VPS)</span>
            </div>
          </div>

          <div className="service-section">
            <h2>Authentication & User Management</h2>
            <div className="service-tags">
              <span>Secure Auth System (JWT + Refresh Tokens + Roles)</span>
              <span>Role-Based Access (Admin/User Permissions)</span>
              <span>Email Verification + Password Reset</span>
              <span>Team Accounts (Multi-User Support)</span>
            </div>
          </div>

          <div className="service-section">
            <h2>Payment & Subscription Services</h2>
            <div className="service-tags">
              <span>
                Stripe Subscription Integration (Monthly/Yearly Plans)
              </span>
              <span>Webhooks (Stripe Events Handling)</span>
              <span>Plan Upgrades/Downgrades</span>
              <span>Usage Limits / Metered Billing</span>
            </div>
          </div>

          <div className="service-section">
            <h2>SaaS Features & Analytics</h2>
            <div className="service-tags">
              <span>Building SaaS MVP (Auth, Billing, Dashboard)</span>
              <span>Basic Analytics (Charts, Stats, Data Visualization)</span>
            </div>
          </div>

          <div className="service-section">
            <h2>Bug Fixing & Enhancements</h2>
            <div className="service-tags">
              <span>React / Node / Express Apps Bug Fixing</span>
              <span>Custom API Routes (Protected/Public)</span>
            </div>
          </div>
        </div> */}
<div className="services-container">
  {[
    {
      title: 'MERN Development Services',
      tags: [
        'Full MERN Stack Web App Development',
        'Custom React Dashboards (Admin Panels / Analytics UI)',
        'Building RESTful APIs with Node/Express/MongoDB',
        'Converting Figma/PSD Designs to React (Responsive)',
        'Integrating 3rd-Party APIs (Stripe, SendGrid, etc.)',
        'MERN App Deployment (Vercel, Render, VPS)',
      ],
    },
    {
      title: 'Authentication & User Management',
      tags: [
        'Secure Auth System (JWT + Refresh Tokens + Roles)',
        'Role-Based Access (Admin/User Permissions)',
        'Email Verification + Password Reset',
        'Team Accounts (Multi-User Support)',
      ],
    },
    {
      title: 'Payment & Subscription Services',
      tags: [
        'Stripe Subscription Integration (Monthly/Yearly Plans)',
        'Webhooks (Stripe Events Handling)',
        'Plan Upgrades/Downgrades',
        'Usage Limits / Metered Billing',
      ],
    },
    {
      title: 'SaaS Features & Analytics',
      tags: [
        'Building SaaS MVP (Auth, Billing, Dashboard)',
        'Basic Analytics (Charts, Stats, Data Visualization)',
      ],
    },
    {
      title: 'Bug Fixing & Enhancements',
      tags: [
        'React / Node / Express Apps Bug Fixing',
        'Custom API Routes (Protected/Public)',
      ],
    },
  ].map((service, index) => (
    <div key={index} className="service-section">
      <h2>{service.title}</h2>
      <div className="service-tags">
        {service.tags.map((tag, idx) => (
          <span key={idx}>{tag}</span>
        ))}
      </div>
    </div>
  ))}
</div>

        <div className="buttonDiv">
          <a href={MohamedAliResume} download className="serviceBtn">
            <span>Download CV</span>
            <Icon icon="line-md:download-loop" width="1.5rem" height="1.5rem" />
          </a>
        </div>
      </motion.div>
      {/* Cards */}
      <div className="cards">
        <motion.div
          initial={{ opacity: 0.5, left: "0%", top: "0%" }}
          whileInView={{ opacity: 1, left: "0%", top: "0%" }}
          transition={transition}
          className="card-technologies"
        >
          <Card
            emoji={v4}
            heading={"Technologies"}
            details={
              "Full Stack Development, JavaScript, TypeScript, React, Next.js, REST APIs, Cloud Services"
            }
            link="https://www.simplilearn.com/top-technology-trends-and-jobs-article"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0.5, left: "0%", top: "0%" }}
          whileInView={{ opacity: 1, left: "30%", top: "10%" }}
          transition={transition}
          className="card-performance"
        >
          <Card
            emoji={v2}
            heading={"Performance"}
            details={
              "SEO Best Practices, Performance Tuning, Integration, Deployment, Hosting"
            }
            link="https://www.techempower.com/benchmarks/#hw=ph&test=fortune&section=data-r22"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0.5, left: "0%", top: "0%" }}
          whileInView={{ opacity: 1, left: "60%", top: "20%" }}
          transition={transition}
          className="card-security"
        >
          <Card
            emoji={tech2}
            heading={"Security"}
            details={
              "Personal Data Encryption, Cybersecurity Defense, Secure Authentication"
            }
            link="https://www.techuk.org/accelerating-innovation/cyber-security.html"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0.5, left: "0%", top: "0%" }}
          whileInView={{ opacity: 1, left: "0%", top: "30%" }}
          transition={transition}
          className="card-speed"
        >
          <Card
            emoji={o}
            heading={"Speed Optimization"}
            details={
              "Fast Loading Times, Code Splitting, Lazy Loading, Image Optimization"
            }
            link="https://www.cloudflare.com/en-gb/learning/performance/speed-up-a-website/"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0.5, left: "0%", top: "0%" }}
          whileInView={{ opacity: 1, left: "30%", top: "40%" }}
          transition={transition}
          className="card-efficiency"
        >
          <Card
            emoji={e}
            heading={"Efficiency"}
            details={
              "Efficient Code, Low Resource Consumption, High Uptime, Scalable Architecture"
            }
            link="https://www.economicshelp.org/blog/glossary/technical-efficiency/"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, left: "0%", top: "0%" }}
          whileInView={{ opacity: 1, left: "60%", top: "48%" }}
          transition={transition}
          className="card-innovation"
        >
          <Card
            emoji={webD}
            heading={"Innovation"}
            details={
              "Cutting-edge Technologies, Creative Solutions, Future-proof Design, Adaptive Strategies"
            }
            link="https://www.techuk.org/tech-and-innovation-programme.html"
          />
        </motion.div>
      </div>
      </div>
    </div>
  );
};

export default Services;
